import {make} from "vuex-pathify"
import PriceTable from "@/API/PriceTables"

const state = {
    isLoading: false,
    form: { },
    page: [],
}

const mutations = make.mutations(state)

const actions = {
    loading({commit}) {
        commit('SET_IS_LOADING', true)
    },
    loaded({commit}) {
        commit('SET_IS_LOADING', false)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
